import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Ticket} from "../Models/ticket";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ClassicType} from "../../shared/models/ClassicType";
import {ApiRestService} from "../_services/api-rest.service";
import {Permission} from "../../Login/_guards/Permission";
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {FileStoreService} from "../../shared/_services/file-store.service";

@Component({
  selector: 'app-ticket-edit',
  templateUrl: './ticket-edit.component.html'
})
export class TicketEditComponent implements OnInit {
  dropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label',
  };
  statiselezionati: ClassicType[] = [];
  tipiselezionati: ClassicType[] = [];
  stati: ClassicType[] = [];
  tipi: ClassicType[] = [];
  @Input() IsModal: boolean = true;
  @Input() selected: Ticket;
  @Output() onSave = new EventEmitter();
  @Input() ticket_id: number;
  constructor(
    private modalService: NgbModal,
    private apirestservice: ApiRestService,
    public permission: Permission,
    private location: Location,
    private route: ActivatedRoute,
    public router: Router,
    private filestore: FileStoreService
  ) { }

  ngOnInit(): void {
    if(this.ticket_id && !this.selected)
      this.getData(this.ticket_id)
    else if (!this.selected)
      this.route.params.subscribe(data => {
        this.getData(parseInt(data['id']))
      })
    this.apirestservice.getTipiTicket().subscribe(data=>{
      this.tipi = data;
    })
    this.apirestservice.getStatiTicket().subscribe(data=>{
      this.stati = data;
    })
  }
  getData(id:number){
    if(isNaN(id))
      this.selected = new Ticket();
    else
      this.apirestservice.getInfoTicket({id:id}).subscribe(data => {
        if(data){
          this.selected = data.data;
          this.filestore.SetListaFile(data.files);
          this.filestore.SelectSection('ticket');
          this.statiselezionati = this.selected && this.selected.statoObject? [this.selected.statoObject] : [];
          this.tipiselezionati = this.selected && this.selected.tipoObject? [this.selected.tipoObject] : [];
        }
      })
  }
  closeBtnClick() {
    if(this.IsModal)
      this.modalService.dismissAll();
    else
      this.location.back();
  }

  saveClick() {
    this.selected.stato = this.getId(this.statiselezionati);
    this.selected.tipo = this.getId(this.tipiselezionati);
    if (this.selected.id)
      this.apirestservice.updateTicket(this.selected).subscribe(() =>this.saved());
    else
      this.apirestservice.addTicket(this.selected).subscribe(() => this.saved());
  }
  saved(){
    this.onSave.emit(this.selected);
    this.closeBtnClick();
  }
  getId(array: any[]) {
    if(array && array[0] && array[0].id)
      return array[0].id;
    return null;
  }

  onFileChanged() {
    this.getData(this.selected?.id);
  }
}
